const pre1980Manufacturers = [
  { manufacturer: "AJS" },
  { manufacturer: "AMC" },
  { manufacturer: "Ace" },
  { manufacturer: "Acme" },
  { manufacturer: "Adler" },
  { manufacturer: "Aermacchi" },
  { manufacturer: "Alcyon" },
  { manufacturer: "Alta" },
  { manufacturer: "Ardie" },
  { manufacturer: "Ariel" },
  { manufacturer: "Atlas Honda" },
  { manufacturer: "BMW" },
  { manufacturer: "BSA" },
  { manufacturer: "Bajaj" },
  { manufacturer: "Balkan" },
  { manufacturer: "Batavus" },
  { manufacturer: "Benelli" },
  { manufacturer: "Bennett \u0026 Barkell" },
  { manufacturer: "Beta" },
  { manufacturer: "Bianchi" },
  { manufacturer: "Bridgestone" },
  { manufacturer: "Brough Superior" },
  { manufacturer: "Bultaco" },
  { manufacturer: "Böhmerland" },
  { manufacturer: "Can-Am" },
  { manufacturer: "Carabela" },
  { manufacturer: "Carpați" },
  { manufacturer: "Casal" },
  { manufacturer: "Ceccato" },
  { manufacturer: "Cleveland" },
  { manufacturer: "Condor" },
  { manufacturer: "Cotton" },
  { manufacturer: "Coventry-Eagle" },
  { manufacturer: "Crocker" },
  { manufacturer: "Cushman" },
  { manufacturer: "DKW" },
  { manufacturer: "DMW" },
  { manufacturer: "DOT" },
  { manufacturer: "Daelim" },
  { manufacturer: "Delta-Gnom" },
  { manufacturer: "Derbi" },
  { manufacturer: "Dollar" },
  { manufacturer: "Douglas" },
  { manufacturer: "Ducati" },
  { manufacturer: "EMW" },
  { manufacturer: "ESO" },
  { manufacturer: "Escorts" },
  { manufacturer: "Excelsior" },
  { manufacturer: "Excelsior (US)" },
  { manufacturer: "Express" },
  { manufacturer: "Eysink" },
  { manufacturer: "FB Mondial" },
  { manufacturer: "FN" },
  { manufacturer: "Famel" },
  { manufacturer: "Fantic" },
  { manufacturer: "Flandria" },
  { manufacturer: "Flying Merkel" },
  { manufacturer: "Francis-Barnett" },
  { manufacturer: "Frera" },
  { manufacturer: "Fuji" },
  { manufacturer: "Garelli" },
  { manufacturer: "Gilera" },
  { manufacturer: "Gillet-Herstal" },
  { manufacturer: "Gnome \u0026 Rhône" },
  { manufacturer: "Greeves" },
  { manufacturer: "Guazzoni" },
  { manufacturer: "HRD" },
  { manufacturer: "Harley-Davidson", value: "HARLEY-DAVIDSON" },
  { manufacturer: "Henderson" },
  { manufacturer: "Hercules" },
  { manufacturer: "Hodaka" },
  { manufacturer: "Honda" },
  { manufacturer: "Horex" },
  { manufacturer: "Humber" },
  { manufacturer: "Husqvarna" },
  { manufacturer: "Hyosung" },
  { manufacturer: "IFA" },
  { manufacturer: "IMZ-Ural" },
  { manufacturer: "IWL" },
  { manufacturer: "IZH" },
  { manufacturer: "Ideal Jawa" },
  { manufacturer: "Indian" },
  { manufacturer: "Innocenti" },
  { manufacturer: "Iso" },
  { manufacturer: "Italjet" },
  { manufacturer: "Iver Johnson" },
  { manufacturer: "JAWA" },
  { manufacturer: "James" },
  { manufacturer: "Jialing" },
  { manufacturer: "Jianshe" },
  { manufacturer: "Junak" },
  { manufacturer: "Juncker" },
  { manufacturer: "KMZ-Dnepr" },
  { manufacturer: "KTM" },
  { manufacturer: "Kawasaki" },
  { manufacturer: "Koehler-Escoffier" },
  { manufacturer: "Komar" },
  { manufacturer: "Kovrovets" },
  { manufacturer: "Kreidler" },
  { manufacturer: "Kymco" },
  { manufacturer: "Laurin \u0026 Klement" },
  { manufacturer: "Laverda" },
  { manufacturer: "Lube" },
  { manufacturer: "MEBEA" },
  { manufacturer: "MV Agusta" },
  { manufacturer: "MZ" },
  { manufacturer: "Macal" },
  { manufacturer: "Magneet" },
  { manufacturer: "Maico" },
  { manufacturer: "Malaguti" },
  { manufacturer: "Malanca" },
  { manufacturer: "Mars" },
  { manufacturer: "Marusho" },
  { manufacturer: "Maserati" },
  { manufacturer: "Matchless" },
  { manufacturer: "Mego" },
  { manufacturer: "Meguro" },
  { manufacturer: "Minarelli" },
  { manufacturer: "Minerva" },
  { manufacturer: "Minsk" },
  { manufacturer: "Mitsubishi" },
  { manufacturer: "Mobra" },
  { manufacturer: "Monark" },
  { manufacturer: "Mondial" },
  { manufacturer: "Monet-Goyon" },
  { manufacturer: "Montesa" },
  { manufacturer: "Morbidelli" },
  { manufacturer: "Moto Guzzi" },
  { manufacturer: "Moto Morini" },
  { manufacturer: "Moto Rumi" },
  { manufacturer: "Motobi" },
  { manufacturer: "Motobécane" },
  { manufacturer: "Motoconfort" },
  { manufacturer: "Motosacoche" },
  { manufacturer: "Motosan" },
  { manufacturer: "Mototrans" },
  { manufacturer: "Mustang" },
  { manufacturer: "NATI" },
  { manufacturer: "NSU" },
  { manufacturer: "NV" },
  { manufacturer: "Nasr" },
  { manufacturer: "Ner-A-Car" },
  { manufacturer: "New Hudson" },
  { manufacturer: "New Imperial" },
  { manufacturer: "New Map" },
  { manufacturer: "Nimbus" },
  { manufacturer: "Norton" },
  { manufacturer: "OK-Supreme" },
  { manufacturer: "Ossa" },
  { manufacturer: "PMZ" },
  { manufacturer: "Panther" },
  { manufacturer: "Parilla" },
  { manufacturer: "Peugeot" },
  { manufacturer: "Pierce" },
  { manufacturer: "Pope" },
  { manufacturer: "Praga" },
  { manufacturer: "Pretis" },
  { manufacturer: "Puch" },
  { manufacturer: "ROG" },
  { manufacturer: "Raleigh" },
  { manufacturer: "Ravat" },
  { manufacturer: "Rickman" },
  { manufacturer: "Rieju" },
  { manufacturer: "Rikuo" },
  { manufacturer: "Roper" },
  { manufacturer: "Royal Enfield" },
  { manufacturer: "Rudge-Whitworth" },
  { manufacturer: "SHL" },
  { manufacturer: "SIS-Sachs" },
  { manufacturer: "SWM" },
  { manufacturer: "Sachs" },
  { manufacturer: "Sanglas" },
  { manufacturer: "Sanyang" },
  { manufacturer: "Saroléa" },
  { manufacturer: "Scott" },
  { manufacturer: "Sears" },
  { manufacturer: "Simplex" },
  { manufacturer: "Simson" },
  { manufacturer: "Sparta" },
  { manufacturer: "Sunbeam" },
  { manufacturer: "Suzuki" },
  { manufacturer: "TIZ" },
  { manufacturer: "TMZ" },
  { manufacturer: "TVS" },
  { manufacturer: "Tempo" },
  { manufacturer: "Terrot" },
  { manufacturer: "Thor" },
  { manufacturer: "Tilbrook" },
  { manufacturer: "Tohatsu" },
  { manufacturer: "Tomos" },
  { manufacturer: "Triumph" },
  { manufacturer: "Tunturi" },
  { manufacturer: "Velocette" },
  { manufacturer: "Vespa" },
  { manufacturer: "Victoria" },
  { manufacturer: "Vilar" },
  { manufacturer: "Villiers" },
  { manufacturer: "Vincent" },
  { manufacturer: "WFM" },
  { manufacturer: "WSK" },
  { manufacturer: "Wagner" },
  { manufacturer: "Wanderer" },
  { manufacturer: "Waratah" },
  { manufacturer: "Whizzer" },
  { manufacturer: "Wooler" },
  { manufacturer: "Yamaha" },
  { manufacturer: "Yankee" },
  { manufacturer: "Zündapp" },
  { manufacturer: "ČZ" },
].map((m) => ({
  label: m.manufacturer,
  value: m.value || m.manufacturer,
}));

export default pre1980Manufacturers;
